import {createContext} from "react";

const TourContext = createContext({
    isTour: false,
    tourId: null,
    tourEntities: [],
    skipToPrev: () => {},
    skipToNext: () => {},
    exitTour: () => {},
    lastTourPos: null, 
    setLastTourPos: () => {},
});

export { TourContext };